
import { useMutation } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { api } from '../../lib/api';

interface VerifyPayload {
  email: string;
  codigo: string;
}

export function useVerificacionEmail() {
  const navigate = useNavigate();
  return useMutation({
    mutationFn: async (payload: VerifyPayload) => {
      const { data } = await api.post('/api/auth/verify-email', payload);
      return data;
    },
    onSuccess: () => {
      toast.success('Correo verificado. Puedes acceder al panel.');
      navigate('/inicio-sesion');
    },
    onError: (error: any) => {
      const message = error.response?.data?.detail ?? 'Código inválido';
      toast.error(message);
    },
  });
}
